export enum GtmEventName {
  LandingPageView = 'landing_page_view',
  SignupFormView = 'signup_form_view',
  SignupEmailStarted = 'signup_email_started',
  SignupContinueClick = 'signup_continue_click',
  SignupGoogleContinueClick = 'signup_google_continue_click',
  LoginFlowSuccess = 'login_flow_success',
  LoginFlowError = 'login_flow_error',
  PasskeyPrompt = 'passkey_prompt',
  PasskeyCreationSuccess = 'passkey_creation_success',
  PasskeyCreationFailure = 'passkey_creation_failure',
  PasskeyAuthenticationSuccess = 'passkey_authentication_success',
  PasskeyAuthenticationFailure = 'passkey_authentication_failure',
  PasskeyFallbackUsed = 'passkey_fallback_used',
  PasswordResetStart = 'password_reset_start',
  ReturningSessionCompleted = 'returning_session_completed',
  RegistrationFormView = 'registration_form_view',
  RegistrationValidationError = 'registration_validation_error',
  RegistrationSubmitted = 'registration_submitted',
  EmailVerified = 'email_verified',
  Registration = 'registration',
  Survey1Submit = 'survey_1_submit',
  Survey2Submit = 'survey_2_submit',
  SurveyCompleted = 'survey_completed',
  ProfileSurveyEnd = 'profile_survey_end',
  FirstProjectComplete = 'first_project_complete',
  SecondProjectComplete = 'second_project_complete',
  Level1Reached = 'level_1_reached',
  FirstWithdrawal = 'first_withdrawal',
  OfferGoalCompleted = 'offer_goal_completed',
  TodayPlanModuleImpression = 'today_plan_module_impression',
  TodayPlanItemImpression = 'today_plan_item_impression',
  TodayPlanCtaClick = 'today_plan_cta_click',
  TodayPlanActionSuccess = 'today_plan_action_success',
  TodayPlanCompletion24h = 'today_plan_completion_24h',
  QuestCandidateImpression = 'quest_candidate_impression',
  QuestCandidateSelection = 'quest_candidate_selection',
  QuestCandidateReroll = 'quest_candidate_reroll',
  QuestFirstProgress = 'quest_first_progress',
  QuestCompletion = 'quest_completion',
  QuestClaim = 'quest_claim',
  QuestDiscard = 'quest_discard',
  QuestExpiry = 'quest_expiry',
  InboxItemOpened = 'inbox_item_opened',
  PwaInstallPromptEligible = 'pwa_install_prompt_eligible',
  PwaInstallCtaDisplayed = 'pwa_install_cta_displayed',
  PwaInstallAccepted = 'pwa_install_accepted',
  PwaInstallDismissed = 'pwa_install_dismissed',
  PwaIosGuidanceDisplayed = 'pwa_ios_guidance_displayed',
  PwaInstalled = 'pwa_installed',
  PwaInstalledLaunch = 'pwa_installed_launch',
  PwaPartnerActivity = 'pwa_partner_activity',
}

export enum GoogleTagEventName {
  AdsConversionSignup = 'ads_conversion_signup',
  AdsConversion = 'ads_conversion',
}
